<template>
  <v-app>
    <div style="z-index: 9999; position: fixed; top: 0; bottom: 0; left: 0; right: 0; background-color: rgba(255, 255, 255, 0.4);"
         v-if="show_global_loader">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
          style="position: absolute; top: calc(50% - 25px); left: calc(50% - 25px);"
      ></v-progress-circular>
    </div>
<!--    width="250"-->
    <v-navigation-drawer
        :clipped="$vuetify.breakpoint.lgAndUp"
        v-model="drawer"
        :mini-variant="mini"
        fixed
        app
        :width="250"
        enable-resize-watcher
        style="box-shadow: 0px 2px 8px rgba(90deg, #FF5E5C 0%, #FF9233 100%); background:#333; opacity:0.75;"
        v-if="get_access_token"
    >
      <!-- <v-img src="../assets/images/background.jpg" height="100%"></v-img> -->
      <span>
      <!-- <a href="/announcements" v-if="!mini" > -->
        <router-link v-if="!mini" to="/announcements" class="white--text">
        <v-img
            :src="require('./assets/images/company_logo.png')"
            class="company_logo"
            style="width: 91px;"
        ></v-img>
      </router-link>
        <!-- </a> -->
        <!-- <a href="/announcements" v-else> -->
      <router-link v-else to="/announcements" class="white--text">
        <v-img
            :src="require('./assets/images/company_logo.png')"
            style="width:35px;"
            class="company_logo"
        ></v-img>
      </router-link>
        <!-- </a> -->
    </span>

      <v-list dense class="align-self-center logo" color="white" contain style="background: none!important;">
          <template v-for="item in items">
            <v-list-group v-if="item.childrens" v-model="item.active" :key="item.text">
              <template v-slot:activator>
                <v-list-tile >
                  <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title class="primary--text">{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>


              <v-list-tile v-for="child in item.childrens" :key="child.title" :to="child.url == '#' ? '' : child.url">
                <v-list-tile style="padding-left: revert;">
                </v-list-tile>

                <v-list-tile-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title class="primary--text">{{ child.text }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
        </v-list-group>

            <v-list-tile v-else :key="item.text" :to="item.url !== '' ? item.url : '#' " >
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title class="primary--text">{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <v-container grid-list-md fluid style="padding-top: 0px;">
        <v-toolbar flat v-if="get_access_token" class="transparent_background">
          <!-- <v-toolbar-title>Title</v-toolbar-title> -->
          <v-toolbar-side-icon
              class="hidden-md-and-down white--text"
              style="background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%) !important"
              @click.stop="drawer = true; mini = !mini"
          ></v-toolbar-side-icon>
          <v-toolbar-side-icon
              class="hidden-lg-and-up white--text"
              style="background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%) !important"
              @click.stop="mini = false; drawer = !drawer"
          ></v-toolbar-side-icon>

          <v-spacer></v-spacer>
          <span v-if="get_user.roles[0].name=='admin'" class="black--text">Hi <b
              class="capitalize">{{ get_user.first_name }}</b> ! You are the <b class="capitalize">Admin</b>,</span>

          <v-menu offset-y left>
            <v-btn icon color="white" large slot="activator" class="table_opacity_8">
              <v-avatar v-if="get_user.profile_image">
                <v-img
                    :src="storage_path()+get_user.profile_image"
                ></v-img>
              </v-avatar>
              <span class="profile_avatar" v-else><b>{{ getInitials }}</b></span>
            </v-btn>
            <v-list>
              <!-- <v-list-tile :to="`/user/${this.$store.getters.get_user.id}`">
                <v-list-tile-title >{{this.$store.getters.get_user.name}}</v-list-tile-title>
              </v-list-tile> -->
              <v-list-tile @click="logout">
                <v-list-tile-title>Logout</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar>

        <v-container fluid grid-list-md class="pb-0" v-if="$route.meta.breadcrumbs ">
          <v-layout row wrap v-if="get_user.roles[0].name !='wm_user'">
            <v-flex xs12>
              <v-breadcrumbs :items="$route.meta.breadcrumbs">
                <template slot="item" slot-scope="props">
                  <router-link
                      class="white--text-bred"
                      to="/serviceRequests"
                      v-if="!props.item.disabled && props.item.text =='Dashboard' && get_user.roles[0].name=='wm_user'"
                  >{{ props.item.text }}
                  </router-link>
                  <router-link
                      class="white--text-bred"
                      :to="props.item.href"
                      v-else-if="!props.item.disabled"
                  >{{ props.item.text }}
                  </router-link>
                  <span v-else class="white--text-bred"><b>{{ props.item.text }}</b></span>
                </template>
                <v-icon slot="divider" class="primary--text">forward</v-icon>
              </v-breadcrumbs>
            </v-flex>
          </v-layout>
        </v-container>

        <router-view :key="$route.fullPath"></router-view>

      </v-container>
      <br>
      <template>
        <v-footer
            height="auto"
            class="transparent_background"
            absolute
        >
          <v-layout
              justify-center
              row
              wrap
          >
            <v-flex
                class="transparent_background "
                py-2
                text-xs-center
                xs12
            >
              <!-- <span style="color: rgba(109,111,113,0.5);">© {{ new Date().getFullYear() }} CDP (India) Pvt. Ltd.</span> -->
            </v-flex>
          </v-layout>
        </v-footer>
      </template>
    </v-content>
  </v-app>


</template>

<script>
import {mapGetters} from "vuex";
// import moment from "moment";
import axios from 'axios';


export default {
  computed: {
    ...mapGetters(["get_access_token", "get_permissions", "get_user", "show_global_loader"]),

    getInitials: function () {
      let blank_index = this.$store.getters.get_user.first_name.indexOf(" ");
      let return_string =
          this.$store.getters.get_user.first_name[0].toUpperCase();
      if (blank_index > -1) {
        return_string +=
            this.$store.getters.get_user.name[blank_index + 1].toUpperCase();
      }
      return return_string;
    },
  },
  watch: {
    get_permissions: {
      deep: true,
      immediate: true,
      handler() {
        this.showSidenav();
      },
    },
  },
  methods: {
    showSidenav() {
      // let val = this.get_user;
      this.filterSideNav();
      /*if (val.roles.length) {
          this.items = this.all_items;
      }*/
    },

    filterSideNav() {
      if (this.get_permissions != null) {
        let permissions = this.get_permissions;

        if (!permissions.length) {
          this.items = [];
        }

        this.items = this.all_items.filter((sidenav) => {
          if (sidenav.permission == '') {
            return true;
          }else{
            return (
                permissions.indexOf(sidenav.permission) > -1
            );
          }
        });
        this.items.forEach(async function(item) {
          let filteredChildren = []
          if(item.childrens) {
            filteredChildren = await item.childrens.filter(sidenavItem => {
              return (permissions.indexOf(sidenavItem.permission) > -1);
            });
            item.childrens = filteredChildren
          }
        });
      }
    },
    
    logout() {
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/logout`, {},
          {
        headers: this.$headers }).then((response)=>{
        if(response.data.status == 1){
          this.items = [];
          localStorage.removeItem("access_token");
          localStorage.removeItem("expiration");
          localStorage.removeItem("permissions");
          localStorage.removeItem("auth_user");
          this.$store.dispatch("removeAccessToken");
          this.$store.dispatch("removePermissions");
          this.$router.push({name: "login"});

        }
      })
    },
  },

  data: () => ({
    loaders: {
      global_search_loader: false,
    },
    global_search_select: null,
    global_search_query: null,
    global_search_items: [],
    dialog: false,
    drawer: true,
    mini: false,
    search_timer: null,
    default_image_path: "/images/default_user.png",
    all_items: [
      {
        icon: "important_devices",
        text: "Monitor",
        permission: "read-monitor",
        active: false,
        childrens: [
          {
            icon: "dashboard",
            text: "Dashboard",
            url: "/",
            permission: "read-dashboard"
          },
          {
            icon: "train",
            text: "Train Tracking",
            url: "/train-tracking",
            permission: "read-train-tracking"
          },
          {
            icon: "train",
            text: "Rake Tracking",
            url: "/rake-tracking",
            permission: "read-rake-tracking"
          },
          {
            icon: "transfer_within_a_station",
            text: "Itinerary Tracking",
            url: "/itinerary-list",
            permission: "read-itineraries"
          },
          {
            icon: "train",
            text: "Train Wise Rake Tracking",
            url: "/train-wise-rake-tracking",
            permission: 'read-train-tracking'
          },
          {
            icon: "train",
            text: "Settlement",
            url: "/ondc-settlement",
            permission: 'read-settlement'
          },
          {
            icon: "train",
            text: "IGM",
            url: "/ondc-issue-grievance",
            permission: 'read-dashboard'
          }
        ]
      },
      {
        icon: "bubble_chart",
        text: "Engage",
        permission: "read-engage",
        active: false,
        childrens: [
          {
            icon: "volume_up",
            text: "Train Updates",
            url: "/trip-announcements",
            permission: "read-trip-announcement"
          },
          {
            icon: "surround_sound",
            text: "Service Alerts",
            url: "/announcements",
            permission: "read-announcement"
          },
          {
            icon: "contact_mail",
            text: "Commute News",
            url: "/news",
            permission: "read-news"
          },
          {
            icon: "notifications",
            text: "Notifications",
            url: "/notifications",
            permission: "read-notification"
          },
          {
            icon: "timer_10",
            text: "IPL Matches",
            url: "/ipl-matches",
            permission: "read-ipl-data"
          },
          {
            icon: "featured_video",
            text: "AbMob Dashboard",
            url: "/ad-mob",
            permission: "read-dashboard"
          },
        ]
      },
      {
        icon: "content_copy",
        text: "User Content",
        permission: "read-user-content",
        active: false,
        childrens: [
          {
            icon: "report_problem",
            text: "Incident report",
            url: "/incident-report",
            permission: "read-incident-report"
          },
          {
            icon: "loyalty",
            text: "Travel Hacks",
            url: "/travelHacks",
            permission: "read-travel-hack"
          },
          {
            icon: "stars",
            text: "Referrals",
            url: "/referral-list",
            permission: "read-referral"
          },
          {
            icon: "subscriptions",
            text: "VIP Subscriptions",
            url: "/vip-subscriptions",
            permission: "read-vip-subscriptions"
          }
        ]
      },
      {
        icon: "assistant",
        text: "User feedbacks",
        permission: "read-user-feedback",
        active: false,
        childrens: [
          {
            icon: "feedback",
            text: "FeedbackList",
            url: "/feedbackList",
            permission: "read-feedbacks"
          },
          {
            icon: "dvr",
            text: "Suggestion",
            url: "/featureSuggestionList",
            permission: "read-suggestions"
          },
        ]
      },
      {
        icon: "nfc",
        text: "Data Masters",
        permission: "import-data-master",
        active: false,
        childrens: [
          // {
          //   icon: "move_to_inbox",
          //   text: "Station Ads Inventory",
          //   url: "/stationAdsInventoryList",
          //   permission: "read-stationadsinventory"
          // },
          {
            icon: "train",
            text: "Local Trains",
            url: "/localTrains",
            permission: "read-trains"
          },
          {
            icon: "file_upload",
            text: "Import Timetable",
            url: "/importMaster",
            permission: "import-masters"
          },
          {
            icon: "select_all",
            text: "Other Masters",
            url: "/masters",
            permission: "read-models"
          },
        ]
      },
      {
        icon: "local_offer",
        text: "Coupon Code",
        url: "/coupon-code",
        permission: "import-data-master"
      },
      {
        icon: "card_giftcard",
        text: "Yatri Campaign",
        permission: "import-data-master",
        active: false,
        childrens: [
          {
            icon: "add_circle",
            text: "Add Campaign",
            url: "/yatri-campaign",
            permission: "import-masters"
          },
          {
            icon: "stars",
            text: "Winners",
            url: "/winners",
            permission: "read-models"
          },
        ]
      },
      {
        icon: "card_giftcard",
        text: "Yatri Festival",
        permission: "import-data-master",
        active: false,
        childrens: [
          {
            icon: "add_circle",
            text: "Add Festival",
            url: "/yatri-festival",
            permission: "import-masters"
          }
        ]
      },
      // {
      //   icon: "supervisor_account",
      //   text: "Yatri Captain",
      //   url: "/yatri-captain",
      //   permission: "import-data-master"
      // },
      // {
      //   icon: "stars",
      //   text: "Yatrikar Moments",
      //   url: "/yartikar-moments",
      //   permission: "read-yatrikar"
      // },
      // {
      //   icon: "volume_mute",
      //   text: "Create WA Announcement",
      //   url: "/waAnnouncements/create",
      //   permission: "create-announcement"
      // },
    ],
    items: [],
    office: {},
  }),
  props: {
    source: String,
  },
  mounted() {
    // this.showSidenav();
    this.$on("permissions-fetched", this.filterSideNav());
  },
};
</script>

<style>
.theme--light .v-list {

  color: rgba(0,0,0,0.87)!important;
}
.v-navigation-drawer .v-list__tile--active {
  box-shadow: inset 0px 0 3px 0 #ff5252 !important;
  background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%) !important;
}

.v-navigation-drawer .v-list__tile__title {
  color: #bdbdbd !important;
}
.v-navigation-drawer--mini-variant {
  width: 96px!important;
}
.white--text-bred {
  color: #fd8e86 !important;
}
.v-list__group__header .v-list__group__header__append-icon{
  padding: 0 3px 0px 3px !important;
}

</style>


